import { message } from 'antd';
import moment from 'moment';
import { getInvoiceReport } from 'network/consignments.api';
import { Dispatch } from 'redux';
import { Buckets } from '../library/Types';
import { ReduxStore } from '../reducers/redux.types';
import {
    endLoading,
    startLoading,
    setGenericData,
    setPagination,
} from './generic-action';

const bucket = Buckets.INVOICE;
const dateFormat = 'MMMM YYYY';

export const loadInvoiceData = () => async (
    dispatch: Dispatch<any>,
    store: () => ReduxStore,
) => {
    dispatch(startLoading(bucket));

    dispatch(setGenericData(bucket, []));

    const { generic } = store();
    const { INVOICE } = generic;
    const { pagination, appliedFilters } = INVOICE;
    const storage = window?.localStorage;
    const id = storage?.getItem('userId');
    const code = storage?.getItem('userCode');

    const response = await getInvoiceReport({
        currentMonth: moment(appliedFilters?.date * 1000).format(dateFormat),
        clientCode: appliedFilters?.customer_code || code,
        clientId: appliedFilters?.customer_id || id,
        currentPageNumber: pagination.currentPageNumber,
        sbu: appliedFilters?.sbu,
    });

    if (response.isSuccess) {
        dispatch(setGenericData(bucket, response?.data?.invoiceData?.map((item: any, index: any) => {
            return {
                ...item,
                key: 50 * (response?.data?.currentPageNumber - 1) + index + 1,
            };
        }) || []));
        dispatch(setPagination(bucket, {
            isNextPresent: response.data?.isNextPresent,
        }));
    } else {
        message.error(response?.errorMessage || 'something went wrong!');
        dispatch(setGenericData(bucket, []));
    }
    dispatch(endLoading(bucket));
};
